export const TextEngineServiceStatus = {
    Idle: 'IDLE',
    Initializing: 'INITIALIZING',
    Ready: 'READY',
    Error: 'ERROR',
    Disposed: 'DISPOSED',
} as const;

export type TextEngineServiceStatus = (typeof TextEngineServiceStatus)[keyof typeof TextEngineServiceStatus];
